import { Spacing, Title } from '@vkontakte/vkui';
import coverImage from 'img/welcome/welcomeDialogNewCover.jpg';
import { ReactComponent as DoneIcon } from 'mrg-icons/src/mailru/status/done.svg';
import React, { memo, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isHideQuotaNewbieFeatureEnabled } from 'reactApp/appHelpers/featuresHelpers';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

import styles from './WelcomeDialogNew.css';

interface IProps {
    onSuccess: () => void;
    onShow: () => void;
}

export const WelcomeDialogNew = memo<IProps>(({ onSuccess, onShow }) => {
    const quota = useSelector(UserSelectors.getCloudSpace);

    useEffect(() => {
        onShow();
    }, []);

    const content = useMemo(() => {
        return (
            <div className={styles.content}>
                <Title level="3" className={styles.title} weight="medium">
                    Надёжное Облако для ваших файлов!
                </Title>
                <Spacing size={16} />
                <ul className={styles.list}>
                    <li className={styles.listItem}>
                        <DoneIcon />
                        Просматривайте любые почтовые вложения
                    </li>
                    {/** tempexp_14483-next-line */}
                    {!isHideQuotaNewbieFeatureEnabled && (
                        <li className={styles.listItem}>
                            <DoneIcon />
                            Используйте {quota.total.value} для хранения своих файлов бесплатно
                        </li>
                    )}
                    <li className={styles.listItem}>
                        <DoneIcon />
                        Делитесь ссылками на фото и видео с друзьями и близкими
                    </li>
                </ul>
                <Spacing size={24} />
            </div>
        );
    }, [quota]);

    const footerText = useMemo(() => {
        return (
            <div className={styles.footerText}>
                Нажимая на кнопку, вы принимаете{' '}
                <a href="https://help.mail.ru/legal/terms/cloud/LA" target="_blank" rel="noreferrer">
                    Лицензионное соглашение
                </a>
                <br />и{' '}
                <a href="https://help.mail.ru/legal/terms/cloud/privacy" target="_blank" rel="noreferrer">
                    Политику конфиденциальности
                </a>
            </div>
        );
    }, []);

    return (
        <WhatsNewDialog
            closable={false}
            onClick={onSuccess}
            primaryButtonText="Хорошо"
            title=""
            content={content}
            imageUrl={coverImage}
            imageBgColor="#ffffff"
            footerText={footerText}
        />
    );
});

WelcomeDialogNew.displayName = 'WelcomeDialogNew';
